.reader {
    position: relative;
    width: 100%;

    &>video {
        width: 100% !important;
    }
}

.codeRect {
    position: absolute;
    border: 2px solid var(--uikit-accent-background-color);
    pointer-events: none;
    transition: all 0.3s ease;
}

@media screen and (max-width: 992px) {
    .reader {
        &>video {
            height: 100% !important;
            width: auto !important;
        }
    }
}